import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { actions } from "store/actions";
import { store } from "store/index";
import { publicRoutes, exposedRoutePages } from "utils/constantValues";
import useNotify from "hooks/useNotify";

// axios instance
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "",
  withCredentials: true,
});

const createCancelRequest = () => {
  const cancelTokenSource = axios.CancelToken.source();
  return Promise.resolve(cancelTokenSource);
};

const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate();
  const { notifyError } = useNotify();
  useEffect(() => {
    const resInterceptor = (response) => {
      console.info("Response interceptor");
      return response.data;
    };

    const errInterceptor = (error) => {
      if (error.response && [401, 403].includes(error.response.status)) {
        const path = window.location.pathname.split("/")[1];
        if (![...publicRoutes, ...exposedRoutePages].includes(path)) {
          store.dispatch(actions.resetUser());
          navigate("/login");
        }
      }
      if (error.response?.data?.message) {
        // notifyError(error.response.data?.message);
      }
      return Promise.reject(error.response.data);
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () => instance.interceptors.response.eject(interceptor);
  }, []);

  return children;
};
export default instance;
export { instance, createCancelRequest, AxiosInterceptor };
